import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
  * **Seekda New Version**
  *
  * @exports bs_458
  * @category engines
  */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.room-wrapper:not(.empty-room), .skd-dsr-room-rates-container, .skd-room-container'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.room-name, .skd-room-title, .skd-dsr-room-title')?.textContent?.trim() || '';
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.rate-plan-wrapper, .skd-room-rate-offer')).map((rate) => {
                const rateName = rate.querySelector('.room-item-name span, .skd-rooms-ratetitle, .skd-dsr-rate-name')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.item-price .price-tag, .skd-room-rate-offer .skd-price-tag')?.textContent);
                const hasBreakfast = !!rate.querySelector('.room-item-policies-wrapper-meal, .fa-coffee');
                const isRefundable = !(rate.querySelector('.bf-icon-circle-notice') && !rate.querySelector('.bf-icon-refresh'));
                if (!ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        boot() {
            const container = document.body;
            if (container) {
                const refreshPage = thn.debounce(() => {
                    const isLoading = thn.isVisible(document.querySelector('.loading-block-wrapper'));
                    if (!isLoading) {
                        thn.pageCheck();
                    }
                }, 900);
                thn.observeDom(container, refreshPage, {
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
            const resultContainer = document.querySelector('#__next');
            if (resultContainer) {
                const refreshPage = thn.debounce(() => {
                    thn.languageCheck().catch(() => { });
                    thn.pageCheck();
                }, 800);
                thn.observeDom(resultContainer, refreshPage, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.pageUnload(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(resultContainer, refreshPage);
                    refreshPage.cancel();
                });
            }
        },
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const bookingEngineLang = document.documentElement.getAttribute('locale') || thn.parseUrlParameter('language') || thn.parseUrlParameter('skd-language-code');
                const homepageLang = document.documentElement.lang?.slice(0, 2);
                const lang = bookingEngineLang || homepageLang;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange() {
            thn.debounce(thn.pageCheck, 800)();
        },
        priceObserveDom(ctx) {
            refreshPrice = thn.debounce(() => {
                ctx.widget.refresh();
            }, 600);
            const { dataLayer } = window;
            if (dataLayer) {
                thn.bus.on('dataLayer:event.viewOffers', refreshPrice);
                thn.bus.on('dataLayer:event.shoppingCartElementRemoved', refreshPrice);
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        thn.bus.detach('dataLayer:event.viewOffers', refreshPrice);
                        thn.bus.detach('dataLayer:event.shoppingCartElementRemoved', refreshPrice);
                    }
                });
            }
            const resultContainer = document.querySelector('.skd-wrapper-result');
            if (resultContainer) {
                thn.observeDom(resultContainer, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(resultContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = (url.search.match(/checkin/) || !!url.search.match(/activeBookingEngine/)) && (url.pathname === '/');
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            // delete all child and adult params of the previous search
            for (const key of Array.from(url.searchParams.keys())) {
                if (key.includes('child') || key.includes('adult')) {
                    url.searchParams.delete(key);
                }
            }
            url.searchParams.delete('skd-checkin');
            url.searchParams.delete('skd-checkout');
            url.searchParams.set('checkin', '[date_begin]');
            url.searchParams.set('checkout', '[date_end]');
            url.searchParams.set('skd-language-code', '[language]');
            url.searchParams.delete('language');
            ctx.newData.dateBegin = ctx.data.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd.replace(/\//g, '-');
            const totalRooms = ctx.data.roomsDispo?.length || 1;
            url.searchParams.set('totalRooms', totalRooms.toString());
            url.searchParams.set('currencyCode', '[currency]');
            if (!thn.empty(ctx.data?.roomsDispo)) {
                for (let i = 0; i < ctx.data.roomsDispo.length; i += 1) {
                    const lengthChildrenAges = ctx.data.roomsDispo?.[i]?.childrenAges?.length || 0;
                    const adults = ctx.data.roomsDispo?.[i]?.adults;
                    for (let c = 0; c < lengthChildrenAges; c += 1) {
                        // child_room[room_index]_age[child_age] = count of children with same age
                        // Ex with two 6 years olds for the second room: "child_room2_age6 = 2"
                        let ageCount = 0;
                        const currentAge = ctx.data.roomsDispo?.[i]?.childrenAges?.[c];
                        // Count duplicated ages
                        const childrenAges = ctx.data.roomsDispo?.[i]?.childrenAges?.length || 0;
                        for (let a = 0; a < childrenAges; a += 1) {
                            if (currentAge === ctx.data.roomsDispo?.[i]?.childrenAges?.[a]) {
                                ageCount += 1;
                            }
                        }
                        if (currentAge) {
                            url.searchParams.set(`child_room${i + 1}_age${currentAge}`, ageCount.toString());
                        }
                    }
                    url.searchParams.set(`adult_room${i + 1}`, adults.toString());
                }
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            const BookingFlowTracker = window.BookingFlowTracker?.tracker;
            // Check if BookingFlowTracker exists and has trackingHistory
            const bookingFlowDataFromWindow = BookingFlowTracker && BookingFlowTracker.trackingHistory
                ? BookingFlowTracker.trackingHistory.filter((event) => event.type === 'viewOffers').pop()
                : null;
            const dataLayer = (window.dataLayer || []);
            const bookingDataPurchase = dataLayer
                .filter((event) => event.event === 'viewOffers')
                .pop();
            const bookingFlowData = bookingFlowDataFromWindow?.data?.eventData || bookingDataPurchase?.bookingFlowData || thn.dataLayerHelper.get('bookingFlowData');
            const searchData = bookingFlowData?.searchData;
            // Guests, Adults & Children
            const currentRoom = thn.parseNumber(document.querySelector('.rate-plan-select-button-wrapper button')?.textContent) || thn.parseNumber(document.querySelector('.rate-plan-select-button-wrapper')?.textContent?.split('#')?.[1]) || 1;
            const adults = searchData?.rooms[currentRoom - 1]?.numberOfAdults || thn.parseNumber(document.querySelector('input.skd-adults')?.value ?? null);
            const children = searchData?.rooms[currentRoom - 1]?.numberOfChildren || thn.parseNumber(document.querySelector('input.skd-children')?.value ?? null) || 0;
            const childrenAges = searchData?.rooms[currentRoom - 1]?.actualAges.map((age) => (age === 0 ? 1 : age)) || Array.from(document.querySelectorAll('.skd-expandable-box-container .skd-children-ages-input option[selected]'))?.map((age) => Number(age?.textContent));
            const roomInfo = {
                adults: Number(adults) ?? 2,
                children: Number(children) ?? 0,
                childrenAges,
            };
            // Dates
            const dateInput = document.querySelector('.skd-checkin');
            const datesFromDom = dateInput?.value?.split('–');
            const dateBegin = (thn.parseUrlParameter('skd-checkin') || thn.parseUrlParameter('checkin') || searchData?.startDate)?.replace(/-/g, '/') || (thn.data.language === 'en' ? datesFromDom?.[0]?.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') : datesFromDom?.[0]?.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
            const dateEnd = (thn.parseUrlParameter('skd-checkout') || thn.parseUrlParameter('checkout') || searchData?.endDate)?.replace(/-/g, '/') || (thn.data.language === 'en' ? datesFromDom?.[1]?.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') : datesFromDom?.[1]?.trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) || searchData?.nights || 1;
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('.item-price .price-tag, .skd-room-rate-offer .skd-price-tag'));
            const prices = pricesEls.map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(pricesEls?.[0]?.textContent || searchData?.currencyCode);
            const noAvailability = thn.empty(prices) || thn.empty(bookingFlowData?.rooms);
            const price = (!thn.empty(prices) && Math.min(...prices)) || bookingFlowData?.minOfferValue;
            if (!thn.empty(price) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    roomDetails: roomDetailsParseData(roomInfo.adults, roomInfo.children),
                    price: price / nights,
                    currency,
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const { dataLayer } = window;
            const bookingDataConfirmed = window.BookingFlowTracker?.tracker?.trackingHistory.find((object) => object.type === 'viewConfirmation');
            // Booking ID
            const bookingId = thn.objectGet(dataLayer, 'reservationId', { first: false }) || thn.parseUrlParameter('bookingid') || document.querySelector('.booking-details-view-details-trigger, .skd-widget-text-success strong')?.textContent || '';
            const isNotValidBooking = thn.empty((Array.isArray(dataLayer) && dataLayer.find((object) => typeof object === 'object' && object !== null && object.event === 'viewConfirmation'))
                || bookingDataConfirmed);
            if (!bookingId || isNotValidBooking) {
                return {
                    set: false,
                };
            }
            const precheckoutObj = window._skd?.serviceLocator?.precheckout?.checkoutParams ?? null;
            const dateBeginFromTracker = (!thn.empty(bookingDataConfirmed) && thn.objectGet(bookingDataConfirmed, 'startDate')) || '';
            const dateEndFromTracker = (!thn.empty(bookingDataConfirmed) && thn.objectGet(bookingDataConfirmed, 'endDate')) || '';
            const dateBeginFromDataLayer = thn.objectGet(dataLayer, 'startDate', { first: false });
            const dateEndFromDataLayer = thn.objectGet(dataLayer, 'endDate', { first: false });
            const dateBegin = (typeof dateBeginFromDataLayer === 'string' ? dateBeginFromDataLayer : dateBeginFromTracker)?.replace(/-/g, '/')
                ?? (typeof precheckoutObj?.checkin === 'string' ? precheckoutObj.checkin.replace(/-/g, '/') : undefined);
            const dateEnd = (typeof dateEndFromDataLayer === 'string' ? dateEndFromDataLayer : dateEndFromTracker)?.replace(/-/g, '/')
                ?? (typeof precheckoutObj?.checkout === 'string' ? precheckoutObj.checkout.replace(/-/g, '/') : undefined);
            // Price & Currency
            const priceEl = document.querySelector('.price-tag')?.textContent;
            const totalPrice = thn.objectGet(dataLayer, 'total', { first: false }) || thn.parseNumber(priceEl);
            const currency = thn.objectGet(dataLayer, 'currencyCode', { first: false }) || thn.parseCurrency(priceEl) || String(precheckoutObj?.currencyCode);
            const rooms = (thn.objectGet(dataLayer, 'rooms', { first: false }) || [])?.length || thn.parseUrlParameter('totalRooms') || thn.parseUrlParameter('skd-total-rooms') || 1;
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price: totalPrice,
                currency,
                rooms,
            };
        },
    };
};

export { factory };
